module.exports = __webpack_public_path__ + "img/relaxtaskreminder.02c41a69.png";